import { AppRegistry } from 'react-native';
import App from './App';

AppRegistry.registerComponent('L3V3LMessenger', () => App);
AppRegistry.runApplication('L3V3LMessenger', {
  rootTag: document.getElementById('root'),
});
